// One card of a dashboard: a screen of the section and its summary of the month

export type ChipTone = 'info' | 'warn' | 'ok';

// Part of a fact line; strong parts are highlighted, e.g. "Maior: **ITSA4** R$ 812,40"
export interface FactPart {
  text: string,
  strong?: boolean
}

export interface DashboardCard {
  icon: string,
  title: string,
  link: string,
  linkLabel: string,
  chip: { text: string, tone: ChipTone } | null,
  figure: string,
  figureNote?: string,
  // Last months, the current one last
  series?: number[] | null,
  facts: FactPart[][]
}

// fact('Maior: ', strong('ITSA4'), ' R$ 812,40')
export function fact(...parts: (string | FactPart)[]): FactPart[] {
  return parts.map(p => typeof p == 'string' ? { text: p } : p);
}

export function strong(text: string): FactPart {
  return { text, strong: true };
}

export function brl(value: number): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function plural(count: number, one: string, many: string): string {
  return `${count} ${count == 1 ? one : many}`;
}
